/**
 * The link `@deepdive-ui` renders through (injected by `UIProvider`).
 *
 * Library and feature code always write canonical paths ('/mentions'); this
 * adds the tree's base ('' live, '/test' mock), so a link can never jump from
 * the test dashboard into the live one. External, hash, `target` and download
 * links stay plain anchors.
 */
import type { LinkComponentProps } from '@deepdive-ui';
import { Link } from 'react-router';

import { useOptionalDataSource } from '@/features/data/DataSourceContext';

import { isExternalHref, withBase } from './paths';


export function RouterLink({ href, ref, ...rest }: LinkComponentProps) {
  const basePath = useOptionalDataSource()?.basePath ?? '';
  if (isExternalHref(href) || rest.target || rest.download !== undefined) {
    // eslint-disable-next-line jsx-a11y/anchor-has-content -- children arrive in rest
    return <a ref={ref} href={href} {...rest} />;
  }
  return <Link ref={ref} to={withBase(basePath, href)} {...rest} />;
}
